import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Box, Button } from "@mui/material";
import '../../styles/ahbaab/MainHomeStyle.css'
import img1 from '../../assest/ahbaab/lab-1.jpg'
import { FaSquareArrowUpRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ThankYouDialoge from "../../components/ThankYouDialoge";
import Header from "../../common/ahbaab/Header/Header";
import TopBannersData from "../../data/ahbaab/TopBannersData";
import OurProductData from "../../data/ahbaab/OurProductData";
// import OurEsteemedClientData from "../../data/ahbaab/OurEsteemedClientData";
import Footer from "../../common/ahbaab/Footer/Footer";
import { MdEmail, MdOutlinePunchClock, MdLocalPhone } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import ValuesData from "../../data/ahbaab/ValuesData";


const myMail = [
    {
        recipient: 'info@qu-lucency.com',
        subject: '',
        body: ''
    },
    {
        recipient: 'sales@qu-lucency.com',
        subject: '',
        body: ''
    }
];

const MainHome = () => {

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };


    const [EnquiryData, SetEnquiryData] = useState({
        name: '',
        email: '',
        mobile: '',
        subject: '',
        message: '',
    })

    const [errorName, setErrorName] = useState("");
    const [errorEmail, setErrorEmail] = useState("");
    const [errorMobile, setErrorMobile] = useState("");
    const [bordrColor, setBordrColor] = useState("");

    const navigate = useNavigate()

    const onInputChnge = (e) => {
        const inpName = e.target.name;
        const inpVal = e.target.value;
        const cloned = { ...EnquiryData }
        cloned[inpName] = inpVal;
        SetEnquiryData(cloned);
    }


    const onSendClick = async (e) => {
        e.preventDefault();

        try {
            // Reset errors and color
            setErrorName("");
            setErrorEmail("");
            setErrorMobile("");
            setBordrColor("");

            // Perform input validation here before making the API call
            if (
                EnquiryData.name.length > 2 &&
                EnquiryData.email.includes("@") &&
                EnquiryData.mobile.length === 10 &&
                EnquiryData.subject.length > 2 &&
                EnquiryData.message.length > 2
            ) {
                setBordrColor('1px solid green');
                const sign_up = await axios.post(
                    'https://api-hosting-production-2021.up.railway.app/api/contact-us',
                    { ...EnquiryData }
                );
                SetEnquiryData(sign_up.data);
                console.log(sign_up.data);

                // Clear the form fields
                SetEnquiryData({
                    name: '',
                    email: '',
                    mobile: '',
                    subject: '',
                    message: '',
                });

                setOpen(true);
                // Provide user feedback or navigation here if needed
                // navigate('/contact')
                console.log('Form data submitted successfully!');
            } else {
                if (EnquiryData.name.length <= 2 || EnquiryData.name === '') setErrorName("enter name");
                if (!EnquiryData.email.includes("@") || EnquiryData.email === '') setErrorEmail("enter email");
                if (EnquiryData.mobile.length !== 10 || EnquiryData.mobile === '') setErrorMobile("enter valid 10 digit number");

                setBordrColor('1px solid white');
                // Provide user feedback for validation errors
                console.log('Form validation failed');
            }
        } catch (error) {
            // Provide user-friendly error message
            console.log('Error submitting form:', error.message);
        }
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 700,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '1px',
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    centerMode: true,
                    centerPadding: '1px',
                },
            },
            {
                breakpoint: 9999, // A large value to ensure the last breakpoint always applies
                settings: {
                    slidesToShow: 4,
                },
            }
        ],
    };

     const dialNumber = () => {
        window.location.href = 'tel:+91 8448783350';
    };

    const emailClick = (recipient, subject, body) => {
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };


    return (
        <>
            <Header />

            <Box id="topSlider-BoxId">
                <Swiper
                    centeredSlides={true}
                    spaceBetween={0}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, Pagination]}
                    className=""
                    style={{ zIndex: -1 }}
                >
                    {TopBannersData?.map(({ id, name, src }) => {
                        return (
                            <SwiperSlide key={id} className="">
                                <div className="custom-img">
                                    <img src={src} alt="img" />
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>

            <Box className='Qu_about_div'>
                <Box className="Qu_about_div_home row">
                    <div className="textdiv col-lg-6 col-12">
                        <p className="small_p">About Us</p>
                        <h6>Company Overview</h6>
                        <p>At Qu-lucency, we are dedicated to supporting pharmaceutical excellence with high-quality cleanroom consumables, defect kits, and a comprehensive range of precision products. Our solutions are designed to meet the stringent standards of the pharmaceutical industry ensuring safety, reliability, and consistency. With a commitment to quality and customer satisfaction, we help our clients maintain clean, compliant, and efficient operations.</p>
                        <div className="moretextdiv">
                            <Link to={'/about-us'}><Button className="morebtn">Read More <FaSquareArrowUpRight className="ms-2 fs-6" /></Button></Link>
                        </div>
                    </div>
                    <div className="imggdiv col-lg-6 col-12">
                        <img src={img1} alt="img" />
                    </div>
                </Box>

            </Box>

            <div className="lucency_productdiv">
                <h1 className=" fw-bold">Our Products</h1>
                <p className="ptag_main">High-quality, innovative, and reliable cleanroom solutions designed to meet stringent standards and support your needs with excellence.</p>
                <div className="qu_slidediv">
                    {OurProductData?.map((item, index) => (
                        <div className="lucency_productdiv_Slider">
                            <Link to={`/products/${item.linkTag}`}>
                                <div key={item.id} className="">
                                    <img src={item.imgSrc} alt={`img-${item.id}`} />
                                    <h4>{item.heading}</h4>
                                </div>
                            </Link>
                            {/* <Link to={`/products/${item.linkTag}`}><Button className="booknowbtn" fullWidth>Read More <FaSquareArrowUpRight className=" ms-2 fs-5" /></Button></Link> */}
                        </div>
                    ))}
                </div>
            </div>

            <div className="WhyChooseUs_div">
                <h1 className=" fw-bold">Core values</h1>
                <div className="WhyChooseUs_slidediv">
                    {ValuesData?.map((item, index) => (
                        <Link>
                            <div key={item.id} className="WhyChooseUs_detail_slide">
                                <img src={item.imgSrc} alt={`img-${item.id}`} />
                                <h4>{item.heading}</h4>
                                <p>{item.textdetail}</p>
                            </div>
                        </Link>

                    ))}
                </div>
            </div>


            {/* <Box className='logistic_Esteemedclients'>
                <h1>Our Esteemed Clients</h1>
                <div className="our_partner">
                    <Slider {...settings}>
                        {OurEsteemedClientData?.map((item, index) => (
                            <div key={item.id} className="Projects_topimg">
                                <img src={item.imgSrc} alt={`img-${item.id}`} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </Box> */}

            <div className="">
                <section className="contact-us section1">
                    <h1 className=" text-center fw-bold pt-5">Get In Touch With Us</h1>
                    <div className="">
                        <div className="inner">
                            <div className="row justify-content-center py-5">
                                <div className="col-lg-6 card-color shadow leftradiusbg">
                                    <div className="contact-us-form">
                                        <h5 className="">
                                            If you have any questions please fell free to contact with
                                            us.
                                        </h5>
                                        <form className="form">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            onChange={onInputChnge}
                                                            value={EnquiryData.name}
                                                            style={{ border: bordrColor, borderRadius: '4px' }}
                                                            placeholder="Name"
                                                            required=""
                                                        />
                                                        <p style={{ color: 'red', fontSize: '12px' }} className="mb-0">{errorName}</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            onChange={onInputChnge}
                                                            value={EnquiryData.email}
                                                            style={{ border: bordrColor, borderRadius: '4px' }}
                                                            placeholder="Email"
                                                            required=""
                                                        />
                                                        <p style={{ color: 'red', fontSize: '12px' }} className="mb-0">{errorEmail}</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            name="mobile"
                                                            onChange={onInputChnge}
                                                            value={EnquiryData.mobile}
                                                            style={{ border: bordrColor, borderRadius: '4px' }}
                                                            placeholder="Phone"
                                                            required=""
                                                        />
                                                        <p style={{ color: 'red', fontSize: '12px' }} className="mb-0">{errorMobile}</p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            name="subject"
                                                            onChange={onInputChnge}
                                                            value={EnquiryData.subject}
                                                            placeholder="Subject"
                                                            required=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <textarea
                                                            name="message"
                                                            onChange={onInputChnge}
                                                            value={EnquiryData.message}
                                                            placeholder="Your Message"
                                                            required=""
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <Button fullWidth onClick={onSendClick} className="btnbtnbgprimary" type="submit">
                                                            Send Message
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className=' col-lg-6 col-12 shadow rightradiusbg'>
                                    <div className="">
                                        <div className="Getcontactdiv">
                                            <div className="ngo_icondiv">
                                                <p> <IoLocationSharp className="icons" /></p>
                                            </div>
                                            <div className="ngocontact">
                                                <p className='addres'>
                                                    303, Kishan apt, Jamia Nagar, New Delhi, South Delhi- 110025, Delhi
                                                </p>
                                            </div>

                                        </div>

                                        <div className="Getcontactdiv">
                                            <div className="ngo_icondiv">
                                                <p> <MdLocalPhone className="icons" /></p>
                                            </div>
                                            <div className="ngocontact">
                                                <p onClick={dialNumber}>+91 8448783350</p>
                                                <span>Have a question? call us now</span>
                                            </div>

                                        </div>

                                        <div className="Getcontactdiv">
                                            <div className="ngo_icondiv">
                                                <p> <MdEmail className="icons" /></p>
                                            </div>
                                            <div className="ngocontact">
                                                {myMail.map((email, index) => (
                                                    <p key={index}
                                                        onClick={() => emailClick(email.recipient, email.subject, email.body)}
                                                    >
                                                        {email.recipient},
                                                    </p>
                                                ))}
                                                <span>Need support? Drop us an email</span>
                                            </div>

                                        </div>

                                        <div className="Getcontactdiv">
                                            <div className="ngo_icondiv">
                                                <p> <MdOutlinePunchClock className="icons" /></p>
                                            </div>
                                            <div className="ngocontact">
                                                <p>Mon - Sat 09:30 - 18:00</p>
                                                <span>We are open on</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </div>

            <ThankYouDialoge open={open} setOpen={setOpen} handleClose={handleClose} />

            <Footer />
        </>
    )
}

export default MainHome